import { MarketComponentStatus } from '../../generated/fresh-guard-api';
import type { TFunction } from 'i18next';

const convertColorToStatus = (
  input: string | undefined,
  translation: TFunction<'translation', undefined>
) => {
  if (input === undefined) {
    return input;
  }

  for (const key of Object.keys(MarketComponentStatus)) {
    const inputPrepared = input.replace('#', '').toLowerCase();
    const keyPrepared = key.toLowerCase();

    if (keyPrepared.includes(inputPrepared)) {
      const statusKey = keyPrepared.replace(inputPrepared, '').toUpperCase();
      const translatedStatus = translation(`apiStatus.${statusKey}`);

      return translatedStatus.toUpperCase();
    }
  }

  return input;
};

export { convertColorToStatus };
